/**
 * Extracts a safe string message from FastAPI error responses.
 * FastAPI Pydantic validation errors return `detail` as an array of objects,
 * which crashes React if passed directly to toast() or JSX rendering.
 */
export function getErrorMessage(error, fallback = "Errore generico") {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map(e => (e.msg || "").replace(/^Value error,\s*/i, ""))
      .filter(Boolean);
    return msgs.length > 0 ? msgs.join(". ") : fallback;
  }
  if (typeof detail === "string") {
    return detail;
  }
  return fallback;
}
